export const REQUEST_MERCHANT_LIST = "REQUEST_MERCHANT_LIST"
export const REQUEST_MERCHANT = "REQUEST_MERCHANT"
export const REQUEST_MERCHANT_CATEGORY_LIST = "REQUEST_MERCHANT_CATEGORY_LIST"